enum CallrailIntegrationMode {
  CREATE_CALLS = 'CREATE_CALLS',
  ENHANCE_CALLS = 'ENHANCE_CALLS',
}

export default CallrailIntegrationMode;
